import { ChallengeCollaboQuestion } from '../../NewChallengeForm.types';

export const DEFAULT_REVIEW_MIN_LENGTH = 15;
export const DEFAULT_REVIEW_QUESTION: ChallengeCollaboQuestion = {
  placeholder: '15자 이상 입력해주세요.',
  question: '',
  reviewMinLength: DEFAULT_REVIEW_MIN_LENGTH,
  isDisplayed: false,
};
